import type {Coordinates} from '../../types';

export const defaultCoordinates: Coordinates = Object.freeze({
  x: 0,
  y: 0,
});



// WEBPACK FOOTER //
// ../src/utilities/coordinates/constants.ts